import { onlineManager } from '@tanstack/react-query';
import { ApiResponse } from 'apisauce';
import { orderRepositoryOfflineAdapters } from '../../../modules/offline/offlineRequestAdapters/order.repository.offlineAdapters';
import { restApi } from '../../api';
import { GetOrderSummaryOutput, GetOrderSummaryParams } from './order.types';

const PATH = 'orders';

export const getOrderSummary = ({
  isOfflineMode,
  ...params
}: GetOrderSummaryParams): Promise<ApiResponse<GetOrderSummaryOutput>> =>
  isOfflineMode || !onlineManager.isOnline()
    ? orderRepositoryOfflineAdapters.calculateSummary(params)
    : restApi.get<GetOrderSummaryOutput>(
        `/${PATH}/${params.orderId}/calculate?${params?.urlParams || ''}`,
      );
